module.exports = "<div class=\"text-center\">\n  <h2 mat-dialog-title>Alert</h2>\n  <mat-dialog-content>{{data.message}}</mat-dialog-content>\n  <div class=\"row justify-content-center\">\n    <mat-dialog-actions>\n      <button mat-button mat-dialog-close>OK</button>\n    </mat-dialog-actions>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog/ok-dialog.component.html
// module id = ./src/app/dialog/ok-dialog.component.html
// module chunks = main